import styled from 'styled-components';

export const Card = styled.div`
  background-color: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: ${props => props.theme.spacing.lg};
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow};
  transition: box-shadow ${props => props.theme.transitions.fast};
  
  ${props => props.hoverable && `
    cursor: pointer;
    
    &:hover {
      box-shadow: 0 4px 16px ${props.theme.colors.shadow};
    }
  `}
`;

export const CardHeader = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
  padding-bottom: ${props => props.theme.spacing.md};
  border-bottom: 1px solid ${props => props.theme.colors.border};
  
  h2, h3 {
    margin-bottom: 0;
  }
`;

export const CardBody = styled.div`
  // Additional styles can be added as needed
`;

export const CardFooter = styled.div`
  margin-top: ${props => props.theme.spacing.md};
  padding-top: ${props => props.theme.spacing.md};
  border-top: 1px solid ${props => props.theme.colors.border};
  display: flex;
  justify-content: ${props => props.align || 'flex-end'};
  gap: ${props => props.theme.spacing.sm};
`;